import type { FluxErrorEntityErrorCodeValue } from '../types.js';

/**
 * Helper function to extract error code strings from error code objects
 * This maintains backward compatibility by converting the new `{ code, message, explanation }` format
 * back to simple string codes for the FluxErrorCodes export
 */
export function extractCode<T extends Record<string, FluxErrorEntityErrorCodeValue<any>>>(
  obj: T,
): {
  [K in keyof T]: T[K] extends { code: infer C } ? C : T[K];
} {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      typeof value === 'string' ? value : value.code,
    ]),
  ) as any;
}
